<div class="panel panel-default" >
    <div class="panel-body" style=" border: #9b7544 2px solid; padding:5px ">
        <ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>
     <div class="form-group">
      Pet Name:<input type="text" [(ngModel)]="pname">
     </div>
     <div class="form-group">
        Pet Type: :<select [(ngModel)]="ptype">
          <option value="dog">Dog</option>
          <option value="cat">Cat</option>
          <option value="bird">Bird</option>
          <option value="smallanimal">Small Animal</option>
         </select>
     </div>
      <div class="form-group">
          Date Of Birth:<input type="date" date="true" time="false" [(ngModel)]="dob"> 
      </div>
      <div class="row">
        <div class="col">
          <button class="btn btn-outline-success" *ngIf="pname&&ptype&&dob" (click)="createPet()">Confirm</button>
        </div>
        <div class="col">
            <button class="btn btn-outline-danger" mat-dialog-close>Cancel</button>
          </div>
      </div>
    </div>
  </div>
